const styles = {
  accordionItem: {
    borderBottom: "1px solid #dce7eb",
  },
  accordionButton: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    padding: "15px 15px 15px 40px",
    position: "relative",
    fontFamily: "CircularStd",
    color: "#6373A4",
  },
  accordionIcon: {
    border: "solid rgb(8, 95, 229)",
    borderWidth: "0 2px 2px 0",
    height: "8px",
    width: "8px",
    pointerEvents: "none",
    position: "absolute",
    left: "15px",
    top: "50%",
    transform: "translateY(-50%) rotate(45deg)",
  },
  accordionIconExpanded: {
    transform: "translateY(-50%) rotate(-135deg)",
  },
  accordionPanel: {
    color: "#000",
    padding: "0 40px 20px 20px",
    "@media (max-width: 1200px)": {
      padding: "0 20px 20px 20px",
    },
  },
  hidden: {
    display: "none",
  },
};

export default styles;
